import { Component, type ReactNode } from 'react'
import { Alert, Button, Stack } from '@mui/material'

type Props = { children: ReactNode }
type State = { hasError: boolean; error?: unknown }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: unknown, info: unknown) {
    // eslint-disable-next-line no-console
    console.error('RPA ErrorBoundary caught:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Stack p={2} spacing={1} role="alert">
          <Alert severity="error">Something went wrong in the UI.</Alert>
          <Button variant="outlined" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </Stack>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
